/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approvals_LabelInputs */



/**
* | output |
* | --- |
* | "Approvals" |
*
* @param {Style_Guide_Manager_Approvals_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approvals_label = /** @type {((inputs?: Style_Guide_Manager_Approvals_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approvals_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Утверждения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审批")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वीकृति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aprovações")
	return /** @type {LocalizedString} */ ("Approvals")
});